export default "__VITE_ASSET__CobgQEzK__"